const areDefined = (...args: unknown[]) => [...args].every((x) => x !== undefined && x !== null);

export default areDefined;
